// @ts-nocheck - form components
import React from 'react';
import KwPanel from '../../common/KwPanel';
import FormInput from '../../common/FormInput';
import { useTranslation } from 'react-i18next';
import FormStatic from '../../common/FormStatic';

export interface AccountDetailsFormProps {
  account: any;
  register: any;
  errors: any;
  control: any;
}

const AccountDetailsForm = ({ account, register, errors, control }: AccountDetailsFormProps) => {
  const { t } = useTranslation();
  return (
    <>
      <KwPanel className="mb-4 pb-3">
        <div className="col-12">
          <header className="mb-2">
            <h2 className="no-margin">{t('Account details')}</h2>
          </header>
        </div>
        <FormStatic label={t('Login')}>{account.login}</FormStatic>
        <FormInput
          register={register}
          required={true}
          error={errors.name}
          errorMessage={t('Required')}
          name="name"
          label={t('Name')}
          placeholder={t('Name of the account')}
          defaultValue={account.name || ''}
          autoFocus={true}
          testId="account-name"
        />
        <FormInput
          register={register}
          required={true}
          error={errors.emailAddress}
          errorMessage={t('Required')}
          name="emailAddress"
          label={t('Email address')}
          placeholder={t('Name of the account')}
          defaultValue={account.emailAddress || ''}
          autoFocus={true}
          testId="account-email-address"
        />
        <FormStatic label={t('Key provider')}>{account.keyProvider}</FormStatic>
      </KwPanel>
    </>
  );
};

export default AccountDetailsForm;
